import React from 'react'
import { createNgReactBridgeDirective } from '../../../react-bridge'
import {
  CurrentOrganization,
  isCurrentOrganization
} from '../../../../components/current-organization'
import { JiraIntegrationIndex } from '../../../../components/integrations/jira/jira-integration-page'
import { ErrorBoundary } from '../../../../legacy-design-system/error-boundary/error-boundary'

interface JiraIntegrationPageBridgeProps {
  readonly currentOrganization: CurrentOrganization | undefined
}

const isValid = (currentOrganization?: CurrentOrganization): boolean => {
  return isCurrentOrganization(currentOrganization)
}

export function JiraIntegrationPageBridge({
  currentOrganization
}: JiraIntegrationPageBridgeProps) {
  return isValid(currentOrganization) ? (
    <ErrorBoundary>
      <JiraIntegrationIndex
        currentOrganization={currentOrganization as CurrentOrganization}
      />
    </ErrorBoundary>
  ) : (
    <></>
  )
}

export const reactJiraIntegrationPage = createNgReactBridgeDirective(
  'reactJiraIntegrationPage',
  [],
  JiraIntegrationPageBridge,
  ['currentOrganization']
)
